import {
    CommonModule,
    HashLocationStrategy,
    LocationStrategy,
    registerLocaleData
} from '@angular/common';
import localePt from "@angular/common/locales/pt";
import { LOCALE_ID, NgModule } from '@angular/core';
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { provideNgxMask } from "ngx-mask";
import { BaseModule } from "../base-module/base.module";
import { UsuariosListaTabelaComponent } from "./lista/tabela/usuarios-lista-tabela.component";
import { UsuariosListaComponent } from "./lista/usuarios-lista.component";
import { RoleCadastrarComponent } from "./role-cadastrar/role-cadastrar.component";
import { RoleListaComponent } from "./role-lista/role-lista.component";
import { RolesService } from "./services/roles.service";
import { UsuariosService } from "./services/usuarios.service";
import { UsuariosCadastrarComponent } from "./usuarios-cadastrar/usuarios-cadastrar.component";
import { UsuarioRoutesModule } from "./usuarios.routing";

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FiltrarUsuariosComponent } from './filtrar-usuarios/filtrar-usuarios.component';
import { PermissaoComponent } from "./permissoes/permissao.component";

registerLocaleData(localePt, "pt");

@NgModule({
    imports: [
        CommonModule,
        UsuarioRoutesModule,
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        MatGridListModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatListModule,
        MatOptionModule,
        MatSelectModule,
        MatSidenavModule,
        MatMenuModule,
        MatAutocompleteModule,
        BaseModule,
        MatDatepickerModule,
        MatTabsModule,
    ],
    declarations: [
        UsuariosListaTabelaComponent,
        UsuariosListaComponent,
        UsuariosCadastrarComponent,
        RoleListaComponent,
        RoleCadastrarComponent,
        PermissaoComponent,
        FiltrarUsuariosComponent,
    ],

    providers: [
        UsuariosService,
        RolesService,
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy,
        },
        {
            provide: LOCALE_ID,
            useValue: "pt"
        },
        provideNgxMask(),
    ],
    exports: [
    ]
})
export class UsuariosModule { }